import React from 'react';
import { ReactComponent as KoalyLogoF } from './koaly_logo_full.svg';
import { ReactComponent as KoalyLogoO } from './koaly_logo_only.svg';
import {Box, Fade, useMediaQuery, useTheme} from "@mui/material";

interface KoalyLogoProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
}

export const KoalyLogoFull: React.FC<KoalyLogoProps> = ({ ...props }) => {
    return <KoalyLogoF color='#004b98' {...props} />;
};

export const KoalyLogoOnly: React.FC<KoalyLogoProps> = ({ ...props }) => {
    return <KoalyLogoO {...props} />;
};

export const KoalyResponsiveLogo: React.FC<KoalyLogoProps> = (props) => {
    const muiTheme = useTheme();
    const isMdUp = useMediaQuery(muiTheme.breakpoints.up('md'));
    return (
        <Fade in key={`${isMdUp}`} appear={false}>
            <Box
                display="flex"
                flexDirection="column"
                alignContent="center"
                sx={{
                    mt: "4px",
                    "& svg": {
                        height: !isMdUp
                            ? { xs: 40, sm: 50 }
                            : { xs: 30, sm: 40 },
                        width: "auto",
                    },
                }}
            >
                {!isMdUp ? (
                    <KoalyLogoOnly {...props} />
                ) : (
                    <KoalyLogoFull {...props} />
                )}
            </Box>
        </Fade>
    );
}